import { applyOverrides } from '@wix/form-conditions';
import { applyNestedFormOverrides } from '@wix/nested-form-overrides';
import { applyNestedForms } from '../../services/apply-nested-forms';
import { applyFormOverrides } from '../../services/form-overrides';
import { validate } from '../../services/validation';
export const validateForm = (formsById, addressTemplates, validationMode, dateTimeOffsetValidationEnabled = false)=>({ formId, values, overrides })=>{
        const form = formsById[formId];
        if (!form) {
            console.error('Trying to validate a form that does not exist');
            return;
        }
        const formWithOverrides = applyNestedForms(applyFormOverrides(applyNestedFormOverrides(applyOverrides(form, values)), overrides ?? {}));
        return validate(formWithOverrides, values, addressTemplates, validationMode, dateTimeOffsetValidationEnabled);
    };

//# sourceMappingURL=validate-form.js.map